import { LitElement, html, css } from 'lit'
import { property } from 'lit/decorators.js'
export class AddButton extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }
    `,
  ]

  static properties = {
    variantId: { type: Number, attribute: 'data-variant-id' },
    productId: { type: Number, attribute: 'data-product-id' },
    productTitle: { type: String, attribute: 'data-product-title' },
    quantity: { type: Number, attribute: 'quantity' },
    selling_plan: { type: Number, attribute: 'data-selling-plan-id' },
    toggle_side_cart: { type: String, attribute: 'data-toggle' },
    upsellPosition: { type: Number, attribute: 'data-upsell-position' },
    type: { type: String, attribute: 'type' },
    saleInclusionMessage: { type: String, attribute: 'data-sale-inclusion-message' },
  }

  constructor() {
    super()
    this.quantity = this.quantity ?? 1
    this.variantId = this.variantId ?? null
    this.productId = this.productId ?? null
    this.productTitle = this.productTitle ?? null
    this.upsellPosition = this.upsellPosition ?? null
    this.selling_plan = this.selling_plan ?? null
    this.toggle_side_cart = this.toggle_side_cart ?? 'true'
    this.type = this.type ?? 'main'
    this.saleInclusionMessage = this.saleInclusionMessage ?? null
  }

  connectedCallback() {
    super.connectedCallback()
  }

  renderButton() {
    return html`
      <div @click=${this._onClick}>
        <slot></slot>
      </div>
    `;
  }
  
  render() {
    return html` ${this.renderButton()} `
  }

  _onClick(e) {
    let data = {
      variant_id: this.variantId,
      quantity: this.quantity,
      toggle_side_cart: this.toggle_side_cart,
      ...(this.saleInclusionMessage !== null ? { properties: { _sale_inclusion_message: this.saleInclusionMessage } } : {}),
    }

    if (this.selling_plan) {
      data.selling_plan = this.selling_plan
    }

    if (this.type === 'cart-upsell' && window?.gtag) {
      window.gtag('event', 'In Cart Upsell Added', {
        itemID: this.variantId,
        event_detail: `${this.productTitle} - ${this.upsellPosition}`,
      })
    } else if (this.type === 'quick-add' && window?.gtag) {
      window.gtag('event', 'Quick Add to Cart', {
        event_detail: this.variantId,
        event_detail2: this.productTitle,
      })

      if (window?.trackIntelligemsEvent) {
        window.trackIntelligemsEvent('Quick Add to Cart', {
          variantId: this.variantId,
          productTitle: this.productTitle,
        })
      }
    } else if (window?.gtag) {
      window.gtag('event', 'Add to Cart', {
        event_detail: this.variantId,
        event_detail2: this.productTitle,
      })
    }

    window.MicroBus.emit('cart:add', data)
    e.preventDefault()
  }
}
customElements.define('add-button', AddButton)
